import { useEffect } from 'react';
import { useNavigate } from '@thd-olt-component-react/router';


export const useEventListener = (props = {}) => {

  const {
    itemId,
    setItemId
  } = props;

  const navigate = useNavigate();

  useEffect(() => {
    // TODO: remove this once the new event bus is in place
    window.LIFE_CYCLE_EVENT_BUS.on('super-sku.change', ({ output }) => {
      const { item, slug, canonicalUrl } = output;
      if (canonicalUrl) {
        navigate(canonicalUrl, { state: { disableScroll: true } });
      }
    });

    // navigation
    window.LIFE_CYCLE_EVENT_BUS.on('fusion-navigate.change', ({ output }) => {
      const {
        path,
        disableScroll = false,
        replace = false
      } = output;
    
      if (path) {
        navigate(path, {
          replace,
          state: {
            disableScroll
          } });
      }
    });

    window.LIFE_CYCLE_EVENT_BUS.on('configurator.configurator_omsId_event', ({ output }) => {
      if (output !== itemId) {
        setItemId(output);
      }
    });

    // @todo sticky nav


  }, []);
}
